/**
 * @generated SignedSource<<b94240259659e06278a2789a949cb783>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MoveChildNodeInput = {
  childToBeMovedId: string;
  clientMutationId?: string | null;
  newParentId: string;
  newPreviousSiblingId?: string | null;
};
export type educationalOfferTree_MoveChildNodeMutation$variables = {
  input: MoveChildNodeInput;
};
export type educationalOfferTree_MoveChildNodeMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly moveChildNode: {
        readonly tree: {
          readonly " $fragmentSpreads": FragmentRefs<"educationalOffer_TreeFragment">;
        };
      } | null;
    };
  };
};
export type educationalOfferTree_MoveChildNodeMutation = {
  response: educationalOfferTree_MoveChildNodeMutation$data;
  variables: educationalOfferTree_MoveChildNodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasBeenPublishedOnce",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "CoordinatesV2",
  "kind": "LinkedField",
  "name": "coordinates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentRef",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitionType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "typeDefinition",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v7/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "childRefs",
          "storageKey": null
        }
      ],
      "type": "BranchTypeDefinition",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contentKind",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "elements",
              "plural": true,
              "selections": [
                (v4/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "elementType",
                  "storageKey": null
                },
                {
                  "kind": "TypeDiscriminator",
                  "abstractKey": "__isElementV2"
                },
                (v5/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "question",
                      "storageKey": null
                    }
                  ],
                  "type": "MultipleChoiceElementV2",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ELearningContentTypeDefinition",
          "abstractKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "rewards",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "kind",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ContentTypeDefinition",
      "abstractKey": "__isContentTypeDefinition"
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Versioning",
  "kind": "LinkedField",
  "name": "versioning",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "draftVersion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "releaseVersion",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rootId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "educationalOfferTree_MoveChildNodeMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "MoveChildNodePayload",
                "kind": "LinkedField",
                "name": "moveChildNode",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Tree",
                    "kind": "LinkedField",
                    "name": "tree",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "educationalOffer_TreeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "educationalOfferTree_MoveChildNodeMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "MoveChildNodePayload",
                "kind": "LinkedField",
                "name": "moveChildNode",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Tree",
                    "kind": "LinkedField",
                    "name": "tree",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TreeNode",
                        "kind": "LinkedField",
                        "name": "rootNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "owner",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currentVersion",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canEdit",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasBeenPublishedToGroupOnce",
                                    "storageKey": null
                                  }
                                ],
                                "type": "RootStructureDefinition",
                                "abstractKey": null
                              },
                              (v6/*: any*/),
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TreeNode",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1ddb4790c01c831f8cd89612fb669b0a",
    "id": null,
    "metadata": {},
    "name": "educationalOfferTree_MoveChildNodeMutation",
    "operationKind": "mutation",
    "text": "mutation educationalOfferTree_MoveChildNodeMutation(\n  $input: MoveChildNodeInput!\n) {\n  Admin {\n    Tree {\n      moveChildNode(input: $input) {\n        tree {\n          ...educationalOffer_TreeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment DeleteChildNodeButton_TreeNodeFragment on TreeNode {\n  id\n  hasBeenPublishedOnce\n  rootId\n}\n\nfragment ElementNode_ElementV2Fragment on ElementV2 {\n  __isElementV2: __typename\n  id\n  title\n  ... on MultipleChoiceElementV2 {\n    question\n  }\n  elementType\n}\n\nfragment NodeConfigurationBadges_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    definitionType\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      rewards {\n        __typename\n        kind\n        id\n      }\n    }\n  }\n  versioning {\n    draftVersion\n    releaseVersion\n  }\n}\n\nfragment Node_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    title\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      contentKind\n    }\n    ... on BranchTypeDefinition {\n      childRefs\n    }\n  }\n  ...NodeConfigurationBadges_TreeNodeFragment\n}\n\nfragment educationalOfferTree_TreeFragment on Tree {\n  id\n  rootNode {\n    id\n    hasBeenPublishedOnce\n    owner\n    status\n    currentVersion\n    canEdit\n    structureDefinition {\n      __typename\n      title\n      ... on RootStructureDefinition {\n        hasBeenPublishedToGroupOnce\n      }\n    }\n    ...educationalOfferTree_TreeNodeFragment\n  }\n  nodes {\n    ...educationalOfferTree_TreeNodeFragment\n    id\n  }\n}\n\nfragment educationalOfferTree_TreeNodeFragment on TreeNode {\n  id\n  hasBeenPublishedOnce\n  parentId\n  structureDefinition {\n    __typename\n    coordinates {\n      parentRef\n    }\n    definitionType\n    title\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on BranchTypeDefinition {\n      childRefs\n    }\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      contentKind\n      ... on ELearningContentTypeDefinition {\n        elements {\n          __typename\n          id\n          elementType\n          ...ElementNode_ElementV2Fragment\n        }\n      }\n    }\n  }\n  ...Node_TreeNodeFragment\n  ...DeleteChildNodeButton_TreeNodeFragment\n}\n\nfragment educationalOffer_TreeFragment on Tree {\n  ...educationalOfferTree_TreeFragment\n}\n"
  }
};
})();

(node as any).hash = "f4ea4d4d814592f4c4b413151adfd265";

export default node;
